import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const OutsourcingAdvantages9 = props => (
    <section id="outsourcing-advantages-section9" className="my pt-5 ">
        <div className='white-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5 blue">{props.t('services:outsourcingAdvantages:section-9.title')}</h2>
            <p className='mb-5'>{props.t('services:outsourcingAdvantages:section-9.txt')}</p>
            {/* Sub-item 1 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingAdvantages:section-9.1.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingAdvantages:section-9.1.text')}</p>
            </div>
            {/* Sub-item 2 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingAdvantages:section-9.2.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingAdvantages:section-9.2.text')}</p>
            </div>
            {/* Sub-item 3 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingAdvantages:section-9.3.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingAdvantages:section-9.3.text')}</p>
            </div>
            {/* Sub-item 4 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingAdvantages:section-9.4.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingAdvantages:section-9.4.text')}</p>
            </div>
            <p>{props.t('services:outsourcingAdvantages:section-9.text')}</p>
        </Container>
    </section>
);

export default OutsourcingAdvantages9;
